import React from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Services data-id="element-2" />
      <HowItWorks data-id="element-3" />
      <Testimonials data-id="element-4" />
      <Pricing data-id="element-5" />
      <FAQ data-id="element-6" />
      <CTA data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}